import productFlags from './components/product-flags';
import productImage from './components/product-image';
import productSwatches from './components/product-swatches';
import productTileBox from './components/product-tile-box';
import productWishlistIcon from './components/product-wishlist-icon';

/**
 * @param {Object} product - product
 * @returns {string} product tile HTML
 */
export default product => {
    let wishlistLink = product.isInWishlist ? Urls.WISHLIST_REMOVE : Urls.WISHLIST_ADD;
    wishlistLink += `?pid=${product.ID}&source=plp`;
    return `
        <div class="product-tile-wrapper"
            data-cnstrc-item-id="${product.ID}"
            data-cnstrc-item-name="${product.name}"
            data-cnstrc-item-variation-id="${product.variationId}"
            data-cnstrc-item-price="${product.priceInfo?.priceValue}"
            >
            <!-- dwMarker="product" dwContentID="${product.UUID}" -->
            <a class="product-tile has-hover-effect"
                id="${product.UUID}" data-itemid="${product.ID}" href="${product.url}"
                title="${product.name}">
                    ${productWishlistIcon(product, wishlistLink)}
                    ${productFlags(product.flags, 'clp')}
                    ${productImage(product, product.swatches?.length > 0, product.lazyLoading)}
                    ${productTileBox(product)}
            </a>
            ${productSwatches(product.swatches)}
        </div>
    `;
};
